import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { ImageUploader } from "components"
import classes from "./OhPaymentDetails.module.scss"

const OhPaymentDetails = props => {
  const { order } = props

  const [t] = useTranslation()

  const showOrderNote =
    order.paymentNote

  const showPaymentAttachUrls =
    order.paymentAttachUrls?.length > 0

  const hide =
    !order.paymentNote &&
    !order.paymentAttachUrls?.length

  if (hide) return null

  return (
    <div className={classes["container"]}>
      <div className={classes["title"]}>
        {t("جزئیات_پرداخت")}
      </div>

      {
        showOrderNote &&
        <div className={classes["payment-details"]}>
          <span className={classes["subtitle"]}>
            {t("یادداشت")}:
          </span>
          <div className={classes["note"]}>
            {order.paymentNote}
          </div>
        </div>
      }

      {
        showPaymentAttachUrls &&
        <Fragment>
          <span className={classes["subtitle"]}>
            {t("پیوست")}:
          </span>
          <ImageUploader
            readOnly
            imageCategory="payment"
            isDeletable={false}
            values={order.paymentAttachUrls}
          />
        </Fragment>
      }
    </div>
  )
}

export default OhPaymentDetails